// extracted by mini-css-extract-plugin
export default {"portlet":"Portlet__portlet--2VV","portletWithCustomStyle":"Portlet__portletWithCustomStyle--3g1"};